import store from './store';




export default function allowAction(page, userAction) {

    const appliedPermissions = store.getState().privilegeManager.appliedPermissions;

    let allow;

    switch (userAction) {

        case 'update':
        case 'edit':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[1] === "1")
            break;

        case 'create':
        case 'add':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[2] === "1")
            break;

        case 'submit':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[3] === "1")
            break;

        case 'cancel':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[4] === "1")
            break;

        case 'delete':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[5] === "1")
            break;

        case 'reject':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[6] === "1")
            break;

        case 'approve':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[7] === "1")
            break;

        case 'admin':
            allow = appliedPermissions.findIndex(x => x.key === page && x.value.split('')[8] === "1")
            break;

        default:
            allow = -1;
    }

    return allow >= 0;
}